module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAPCAYAAADtc08vAAAAOklEQVQokWP8DwQMFAAWEPH46QuyNMtKS0AMAHNkJEnS/PjJczDNRJbVSGDUgFEDBocB8LwAS9ukAgDSQQzO6AO7WgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/word/wdystb1-3.png
// module id = 890
// module chunks = 0